export default {
	title: 'जोखिम / ओपनिंग',
	risks: 'जोखिम',
	opportunities: 'ओपनिंग',
	url: 'risks',
	subtitle: '',
	all_categories: 'श्रेणी फ़िल्टर',
	all_impacts: 'प्रभाव फ़िल्टर',
	all_likelihoods: 'संभावना फ़िल्टर',
	all_stakeholders: 'हितधारक फ़िल्टर',
	all_stakes: 'हित फ़िल्टर',
	no_stakeholder: 'कोई हितधारक नहीं',
	tabs: {
		filters: {
			title: 'दृश्य फ़िल्टर',

			displayed_columns: 'प्रदर्शित स्तंभ',
			visualization_options: 'दृश्य विकल्प'
		},
		options: {
			title: 'प्रदर्शन',
			are_links_visible: 'सभी लिंक दिखाएँ',
			show_description: 'विवरण दिखाएँ',
			chart_visible_stakes: 'हित दिखाएँ',
			chart_visible_stakeholders: 'हितधारक दिखाएँ',
			chart_visible_risks: 'जोखिम दिखाएँ',
			chart_visible_opportunities: 'ओपनिंग दिखाएँ'
		},
		general: {
			title: 'सामान्य'
		},
		stakeholders: {
			title: 'हितधारक'
		},
		export: {
			title: 'निर्यात'
		},
		comments: {
			title: 'इतिहास'
		}
	},
	visualization_tab: 'दृश्यीकरण',
	onboarding: {
		risks: {
			title: 'जोखिमों की समीक्षा',
			description:
				'ये जोखिम हैं जो आपके हितों पर भार डालते हैं। उनकी संभावना और प्रभाव का आकलन करें, और जो आपको ग़लत ढंग से कैलिब्रेटेड लगें उन्हें ठीक करें।'
		},
		opportunities: {
			title: 'ओपनिंग की समीक्षा',
			description:
				'जोखिमों के विपरीत, ओपनिंग वे गतिशीलताएँ हैं जो आपके हितों को मज़बूत कर सकती हैं। कार्यान्वयन योग्य रखें, बाक़ी को छोड़ दें।'
		}
	}
};
